import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './App.scss'
// bootstrap includes
import { Container, Row, Col, Nav } from 'react-bootstrap'

import { ReactComponent as Logo } from './images/challenge_navy.svg'
import { ReactComponent as Twitter } from './images/twitter.svg'
import { ReactComponent as Facebook } from './images/facebook.svg'
import { ReactComponent as Instagram } from './images/instagram.svg'
import { ReactComponent as Linkedin } from './images/linkedin.svg'
import { ReactComponent as Youtube } from './images/youtube.svg'

const Socials = () => {
  return (
    <div className="social">
      <div className="social-link">
        {/* <Twitter id="twitter" /> */}
        <a
          href="https://www.instagram.com/challengemachinery/"
          target="_blank"
          rel="noreferrer"
        >
          <Instagram id="instagram" />
        </a>
        {/* <Linkedin id="linkedin" /> */}
        <a
          href="https://www.linkedin.com/company/the-challenge-machinery-company/"
          target="_blank"
          rel="noreferrer"
        >
          <Linkedin id="linkedin" />
        </a>
        {/* <Youtube id="Youtube" /> */}
        <a
          href="https://www.youtube.com/@ChallengeMachinery/"
          target="_blank"
          rel="noreferrer"
        >
          <Youtube id="Youtube" />
        </a>
      </div>
    </div>
  )
}

const DesktopFooter = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs={4} sm={3}>
          <Link to="/">
            <Logo className="sm_logo" />
          </Link>
        </Col>
        <Col>
          <div id="foot-nav">
            <Nav>
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/products">
                Products
              </Nav.Link>
              <Nav.Link as={Link} to="/support">
                Support
              </Nav.Link>
              <Nav.Link as={Link} to="/dealers">
                Dealers
              </Nav.Link>
              <Nav.Link as={Link} to="/about">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                Contact
              </Nav.Link>
            </Nav>
          </div>
          <div id="foot-content">
            <p>© 2025 The Challenge Machinery Company, USA.</p>
          </div>
          <div id="foot-nav">
            <Nav>
              <Nav.Link as={Link} to="/privacy">
                Privacy
              </Nav.Link>
              <Nav.Link as={Link} to="/terms">
                Terms
              </Nav.Link>
              <Nav.Link as={Link} to="/cookies">
                Cookies
              </Nav.Link>
            </Nav>
          </div>
        </Col>
        <Col xs={4} sm={3}>
          <Socials />
        </Col>
      </Row>
    </Container>
  )
}

const MobileFooter = () => {
  return (
    <Container>
      <Row>
        <Col xs={4} sm={3}>
          <Link to="/">
            <Logo className="sm_logo" />
          </Link>
        </Col>
        <Col>
          <div id="foot-nav">
            <Nav>
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/products">
                Products
              </Nav.Link>
              <Nav.Link as={Link} to="/support">
                Support
              </Nav.Link>
              <Nav.Link as={Link} to="/dealers">
                Dealers
              </Nav.Link>
              <Nav.Link as={Link} to="/about">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                Contact
              </Nav.Link>
            </Nav>
          </div>
          <div id="foot-content">
            <p>© 2025 The Challenge Machinery Company, USA.</p>
          </div>
          <div id="foot-nav">
            <Nav>
              <Nav.Link as={Link} to="/privacy">
                Privacy
              </Nav.Link>
              <Nav.Link as={Link} to="/terms">
                Terms
              </Nav.Link>
              <Nav.Link as={Link} to="/cookies">
                Cookies
              </Nav.Link>
            </Nav>
          </div>
        </Col>
        <Col xs={4} sm={3}>
          <Socials />
        </Col>
      </Row>
    </Container>
  )
}

const Footer = (): JSX.Element => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })
  const breakpoint = 992
  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return dimensions.width < breakpoint ? <MobileFooter /> : <DesktopFooter />
}

export default Footer
